import 'css-chunksrc/client/scenes/optimizedGantt/graph/styles.scss';export default {
  "graph": "_graph_l4r7y_1",
  "main": "_main_l4r7y_7"
};